export const NEW_PROJECT_DIALOG_OUTLET = 'new-project-dialog';
export const NEW_PROJECT_DIALOG_LINK = ['/', { outlets: { [NEW_PROJECT_DIALOG_OUTLET]: ['overview'] } }];
